exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chargedPrice--17ld6{font-size:12px;color:#8b8d8d}.price--_Tldd{display:flex;flex-direction:column;align-items:flex-end}.convertInfo---OXOa{font-size:12px;color:#8b8d8d}", ""]);

// Exports
exports.locals = {
	"chargedPrice": "chargedPrice--17ld6",
	"price": "price--_Tldd",
	"convertInfo": "convertInfo---OXOa"
};